export const uploadFilesPublicity = {
  placeholder: 'Publicidad',
  document_tag: 'PUBLICITY_FUND',
  constancy_filename: '',
  constancy_url: '',
  sign: false,
}
